import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import {Flex, Box} from 'reflexbox/styled-components'
import styles from './Navigation.module.css'
import Logo from "../../images/logo.inline.svg";

const StyledLogo = styled(Logo)`
  width: 40px;
  height: auto;
`

const StyledA = styled.a`
  text-decoration: none;
`

const Navigation = () => (
  <Flex role="navigation" alignItems="center">
    <Box>
      <StyledA href="https://shoekicker.com/">
        <StyledLogo />
      </StyledA>
    </Box>
  </Flex>
)

export default Navigation
